<template>
  <v-dialog v-model="dialogOpen" persistent max-width="500px">
    <v-card>
      <v-card-title>
        <span>{{ dialogTitle }}</span>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-container grid-list-lg text-xs-left>
        <v-layout column wrap>
          <v-flex>
            <div class="c-msg">{{ dialogMessage }}</div>
          </v-flex>
          <v-flex>
            <v-list class="c-com-list no-hand">
              <template v-for="(community, index) in communities">
                <v-divider v-if="index > 0"></v-divider>

                <v-list-tile :key="community.id" avatar @click="">
                  <v-list-tile-avatar>
                    <c-img :src="'/cover/c/' + community.id + ''" />
                  </v-list-tile-avatar>

                  <v-list-tile-content>
                    <v-list-tile-title>{{ community.name }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </v-list>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="clr-btn-cancel" flat @click.native="cancel">{{ $T('button.cancel') }}</v-btn>
        <v-btn color="clr-btn" flat @click.native="ok">{{ $T('button.ok') }}</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialogTitle: { type: String, required: true },
    dialogMessage: { type: String, required: true },
  },
  data() {
    return {
      title: this.dialogTitle,
      msg: this.dialogTitle,
      dialogOpen: false,
      communities: null,
      targetObject: null,
    };
  },
  methods: {
    open(communities, obj) {
      this.communities = communities;
      this.targetObject = obj;
      this.dialogOpen = true;
    },
    close() {
      this.dialogOpen = false;
    },
    cancel() {
      this.$emit('cancel', this.targetObject);
      this.dialogOpen = false;
    },
    ok() {
      this.$emit('ok', this.targetObject);
      this.dialogOpen = false;
    },
  },
};
</script>

<style scoped>
.container {
  padding: 0px 24px 12px 24px;
}
.c-com-list {
  border: 1px solid rgba(0, 0, 0, 0.12);
  padding: 0 !important;
}
</style>
